
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/branding-design/get-started/[[...params]]",
      function () {
        return require("private-next-pages/branding-design/get-started/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/branding-design/get-started/[[...params]]"])
      });
    }
  